"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.preview.title': 'Anteprima avatar',
    'avatar.preview.edit': 'Modifica avatar',
    'avatar.preview.back': 'Torna alla lista',
    'avatar.preview.not_provided': 'Non fornito',
    'avatar.preview.section.basic_info': 'Informazioni di base',
    'avatar.preview.section.logo': 'Logo avatar',
    'avatar.preview.section.description': 'Descrizione',
    'avatar.preview.section.ai_model': 'Configurazione modello IA',
    'avatar.preview.section.knowledge': 'Base di conoscenza',
    'avatar.preview.section.settings': 'Impostazioni avatar',
    'avatar.preview.section.validation': 'Stato configurazione',
    'avatar.preview.logo.not_uploaded': 'Nessun logo caricato',
    'avatar.preview.provider': 'Fornitore',
    'avatar.preview.cost': 'Costo',
    'avatar.preview.model.not_selected': 'Nessun modello IA selezionato - Questo è richiesto!',
    'avatar.preview.knowledge.entries_selected': 'voci di conoscenza selezionate',
    'avatar.preview.knowledge.none_selected': 'Nessuna voce della base di conoscenza selezionata',
    'avatar.preview.validation.status': 'Validazione configurazione',
    'avatar.preview.validation.complete': 'Tutti i campi richiesti sono completati',
    'avatar.preview.validation.incomplete': 'Alcuni campi richiesti mancano',
    'avatar.preview.no_data': 'Nessun dato avatar disponibile',
    'avatar.preview.error.load_failed': 'Errore nel caricamento dell\'avatar per l\'anteprima',
    'avatar.preview.voice.not_selected': 'Nessuna voce selezionata',
    'avatar.preview.unnamed': 'Avatar Senza Nome',
    'avatar.preview.required': 'Richiesto',
    'avatar.preview.gender.not_selected': 'Nessun genere selezionato',
    'avatar.preview.section.conversations': 'Conversazioni',
    'avatar.preview.conversations.empty': 'Nessuna conversazione con questo avatar ancora',
    'avatar.preview.conversations.untitled': 'Conversazione senza titolo',
};
